import { put } from "../../utils/api";
import GenericViewDrawer1 from "./GenericViewDrawer1";

const WasteGeneratedView = ({
  open,
  onClose,
  data,
  setsnackOpen,
  fetchDataCallback,
  apiUrl,
}) => {
  if (!data) return null;

  const handleApprovalAction = async (action) => {
    try {
      const response = await put(`${apiUrl}/${data._id}`, {
        approvalStatus: action === "approve" ? "Accepted" : "Rejected",
      });
      if (response?.data) {
        setsnackOpen({
          open: true,
          message: response.data.message,
          severity: "success",
        });
        fetchDataCallback();
        onClose();
      }
    } catch (error) {
      setsnackOpen({
        open: true,
        message: error.message || "An error occurred",
        severity: "error",
      });
    }
  };

  const fields = [
    {
      label: "Consumption Month",
      previous: `${data?.consumptionPeriod?.month}/${data?.consumptionPeriod?.year}`,
      requested: `${data?.editValue?.consumptionPeriod?.month || "—"}/${
        data?.editValue?.consumptionPeriod?.year || "—"
      }`,
    },
    {
      label: "Waste Category",
      previous: data?.wasteCategory,
      requested: data?.editValue?.wasteCategory,
    },
    {
      label: "Waste Type",
      previous: data?.wasteType,
      requested: data?.editValue?.wasteType,
    },
    {
      label: "Quantity of Waste Generated",
      previous: data?.quantityOfWasteGenerated?.value
        ? `${data.quantityOfWasteGenerated.value} ${data.quantityOfWasteGenerated.unit}`
        : "—",
      requested: data?.editValue?.quantityOfWasteGenerated?.value
        ? `${data.editValue.quantityOfWasteGenerated.value} ${data.editValue.quantityOfWasteGenerated.unit}`
        : "—",
    },
    {
      label: "Waste Management Method",
      previous: data?.wasteManagementMethod,
      requested: data?.editValue?.wasteManagementMethod,
    },
    {
      label: "Vendor",
      previous: data?.vendor?.vendorLegalName || "-",
      requested: data.editValue?.equipmentData?.vendorLegalName || "-",
    },
    {
      label: "Quantity of Waste Managed",
      previous: data?.quantityOfWasteManaged?.value
        ? `${data.quantityOfWasteManaged.value} ${data.quantityOfWasteManaged.unit}`
        : "—",
      requested: data?.editValue?.quantityOfWasteManaged?.value
        ? `${data.editValue.quantityOfWasteManaged.value} ${data.editValue.quantityOfWasteManaged.unit}`
        : "—",
    },
    {
      label: "Remark",
      previous: data?.remark,
      requested: data?.editValue?.remark,
    },
  ];

  return (
    <GenericViewDrawer1
      open={open}
      onClose={onClose}
      title="Waste Generated"
      fields={fields}
      documentsField={{
        label: "Documents",
        previous: data?.documents,
        requested: data?.editValue?.documents,
      }}
      timeline={data?.timeLine}
      editRemarkReason={data?.editRemarkReason}
      onApprove={() => handleApprovalAction("approve")}
      onReject={() => handleApprovalAction("reject")}
    />
  );
};

export default WasteGeneratedView;

// import React from "react";
// import {
//   Drawer,
//   Box,
//   Typography,
//   Divider,
//   Button,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Paper,
//   Stack,
// } from "@mui/material";
// import DocumentItem from "../../Components/Masters/DocumentItem";
// import { put } from "../../utils/api";

// const WasteGeneratedView = ({
//   open,
//   onClose,
//   data,
//   setsnackOpen,
//   fetchDataCallback,
//   apiUrl,
// }) => {
//   if (!data) return null;

//   const handleApprovalAction = async (action) => {
//     try {
//       const response = await put(`${apiUrl}/${data._id}`, {
//         approvalStatus: action === "approve" ? "Accepted" : "Rejected",
//       });
//       if (response?.data) {
//         setsnackOpen({
//           open: true,
//           message: response.data.message,
//           severity: "success",
//         });
//         fetchDataCallback();
//         onClose();
//       }
//     } catch (error) {
//       setsnackOpen({
//         open: true,
//         message: error.message || "An error occurred",
//         severity: "error",
//       });
//     }
//   };

//   const renderValue = (original, edited) => (
//     <>
//       <TableCell>{original ?? "—"}</TableCell>
//       <TableCell>{edited ?? "—"}</TableCell>
//     </>
//   );

//   return (
//     <Drawer anchor="right" open={open} onClose={onClose}>
//       <Box width="90vw" maxWidth={1000} p={3}>
//         <Typography variant="h6" fontWeight="bold" gutterBottom>
//           Waste Management Entry Details
//         </Typography>
//         <Divider sx={{ mb: 2 }} />

//         <TableContainer component={Paper} sx={{ mb: 3 }}>
//           <Table size="small">
//             <TableHead>
//               <TableRow>
//                 <TableCell><strong>Field</strong></TableCell>
//                 <TableCell><strong>Previous</strong></TableCell>
//                 <TableCell><strong>Requested</strong></TableCell>
//               </TableRow>
//             </TableHead>
//             <TableBody>
//               <TableRow>
//                 <TableCell>Year</TableCell>
//                 {renderValue(data?.consumptionPeriod?.year, data?.editValue?.consumptionPeriod?.year)}
//               </TableRow>
//               <TableRow>
//                 <TableCell>Month</TableCell>
//                 {renderValue(data?.consumptionPeriod?.month, data?.editValue?.consumptionPeriod?.month)}
//               </TableRow>
//               <TableRow>
//                 <TableCell>Waste Category</TableCell>
//                 {renderValue(data?.wasteCategory, data?.editValue?.wasteCategory)}
//               </TableRow>
//               <TableRow>
//                 <TableCell>Waste Type</TableCell>
//                 {renderValue(data?.wasteType, data?.editValue?.wasteType)}
//               </TableRow>
//               <TableRow>
//                 <TableCell>Quantity of Waste Generated</TableCell>
//                 {renderValue(
//                   data?.quantityOfWasteGenerated?.value
//                     ? `${data.quantityOfWasteGenerated.value} ${data.quantityOfWasteGenerated.unit}`
//                     : "—",
//                   data?.editValue?.quantityOfWasteGenerated?.value
//                     ? `${data.editValue.quantityOfWasteGenerated.value} ${data.editValue.quantityOfWasteGenerated.unit}`
//                     : "—"
//                 )}
//               </TableRow>
//               <TableRow>
//                 <TableCell>Waste Management Method</TableCell>
//                 {renderValue(data?.wasteManagementMethod, data?.editValue?.wasteManagementMethod)}
//               </TableRow>
//               <TableRow>
//                 <TableCell>Vendor</TableCell>
//                 {renderValue(data?.vendorName?.name, data?.editValue?.vendorName?.name)}
//               </TableRow>
//               <TableRow>
//                 <TableCell>Quantity of Waste Managed</TableCell>
//                 {renderValue(
//                   data?.quantityOfWasteManaged?.value
//                     ? `${data.quantityOfWasteManaged.value} ${data.quantityOfWasteManaged.unit}`
//                     : "—",
//                   data?.editValue?.quantityOfWasteManaged?.value
//                     ? `${data.editValue.quantityOfWasteManaged.value} ${data.editValue.quantityOfWasteManaged.unit}`
//                     : "—"
//                 )}
//               </TableRow>
//               <TableRow>
//                 <TableCell>Remark</TableCell>
//                 {renderValue(data?.remark, data?.editValue?.remark)}
//               </TableRow>

//               <TableRow>
//                 <TableCell>Documents</TableCell>
//                 <TableCell>
//                   <Box display="flex" flexWrap="wrap" gap={1}>
//                     {data?.documents?.length > 0
//                       ? data.documents.map((url, i) => (
//                           <DocumentItem key={`doc-${i}`} url={url} />
//                         ))
//                       : "—"}
//                   </Box>
//                 </TableCell>
//                 <TableCell>
//                   <Box display="flex" flexWrap="wrap" gap={1}>
//                     {data?.editValue?.documents?.length > 0
//                       ? data.editValue.documents.map((url, i) => (
//                           <DocumentItem key={`edit-doc-${i}`} url={url} />
//                         ))
//                       : "—"}
//                   </Box>
//                 </TableCell>
//               </TableRow>
//             </TableBody>
//           </Table>
//         </TableContainer>

//         {/* Timeline Info */}
//         <Box display="flex" flexDirection="column" gap={1}>
//           {Array.isArray(data?.timeLine) && data.timeLine.length > 0 ? (
//             (() => {
//               const lastEntryArray = [...data.timeLine]
//                 .reverse()
//                 .find((arr) => Array.isArray(arr) && arr.length > 0);

//               if (!lastEntryArray || lastEntryArray.length === 0) return null;

//               const lastEntry = lastEntryArray[lastEntryArray.length - 1];
//               const timestamp = new Date(lastEntry.timeStamp);
//               const date = timestamp.toLocaleDateString("en-IN");
//               const time = timestamp.toLocaleTimeString("en-IN", {
//                 hour: "2-digit",
//                 minute: "2-digit",
//                 second: "2-digit",
//               });

//               return (
//                 <>
//                   <Typography variant="body2">
//                     <strong>Created By:</strong> {lastEntry?.name}
//                   </Typography>
//                   <Typography variant="body2">
//                     <strong>Remark Reason:</strong> {data?.editRemarkReason || "—"}
//                   </Typography>
//                   <Typography variant="body2">
//                     <strong>Date:</strong> {date}
//                   </Typography>
//                   <Typography variant="body2">
//                     <strong>Time:</strong> {time}
//                   </Typography>
//                 </>
//               );
//             })()
//           ) : (
//             <Typography variant="body2">No timeline history available</Typography>
//           )}
//         </Box>

//         {/* Action Buttons */}
//         <Stack direction="row" spacing={2} mt={4} justifyContent="flex-end">
//           <Button
//             variant="contained"
//             color="success"
//             onClick={() => handleApprovalAction("approve")}
//           >
//             Approve
//           </Button>
//           <Button
//             variant="outlined"
//             color="error"
//             onClick={() => handleApprovalAction("reject")}
//           >
//             Reject
//           </Button>
//         </Stack>
//       </Box>
//     </Drawer>
//   );
// };

// export default WasteGeneratedView;
